import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Moment } from "moment";
import styles from "../../Styles/calendarDashboard.module.css";
import { Vocabulary } from "../../Utils/Vocabulary";

export type CalendarView = "month" | "week";

type Props = {
  currentDate: Moment;
  view: CalendarView;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
  onViewChange: (view: CalendarView) => void;
};

function formatPeriodLabel(date: Moment, view: CalendarView): string {
  if (view === "month") {
    return date.format("MMMM YYYY");
  }
  const start = date.clone().startOf("isoWeek");
  const end = date.clone().endOf("isoWeek");
  if (start.month() === end.month()) {
    return `${start.format("D")} – ${end.format("D MMMM YYYY")}`;
  }
  if (start.year() === end.year()) {
    return `${start.format("D MMM")} – ${end.format("D MMM YYYY")}`;
  }
  return `${start.format("D MMM YYYY")} – ${end.format("D MMM YYYY")}`;
}

export default function CalendarHeader({
  currentDate,
  view,
  onPrev,
  onNext,
  onToday,
  onViewChange,
}: Props) {
  return (
    <div className={styles.header}>
      <div className={styles.headerLeft}>
        <button className={styles.navButton} onClick={onPrev} aria-label="Previous">
          <ChevronLeftIcon fontSize="small" />
        </button>
        <button className={styles.navButton} onClick={onNext} aria-label="Next">
          <ChevronRightIcon fontSize="small" />
        </button>
        <span className={styles.periodLabel}>
          {formatPeriodLabel(currentDate, view)}
        </span>
      </div>

      <div className={styles.headerRight}>
        <button className={styles.todayButton} onClick={onToday}>
          {Vocabulary.calendarToday}
        </button>

        <div className={styles.viewToggle}>
          <button
            className={`${styles.viewButton} ${view === "month" ? styles.viewButtonActive : ""}`}
            onClick={() => onViewChange("month")}
          >
            {Vocabulary.calendarMonth}
          </button>
          <button
            className={`${styles.viewButton} ${view === "week" ? styles.viewButtonActive : ""}`}
            onClick={() => onViewChange("week")}
          >
            {Vocabulary.calendarWeek}
          </button>
        </div>
      </div>
    </div>
  );
}
